import React from 'react';
import { FieldChangeGrid } from '@pages/admin/audit-log/change-grid';
import { getFieldChangeItems, getProcessedFieldChangeItems } from '@pages/admin/audit-log/service';

const StudyHubStudyFieldsChangeGrid = ({ oldRecord, newRecord, oldItem, newItem }: any) => {
    const refactoredOldRecord = oldRecord
        ? {
              ...oldRecord,
              CfId: oldRecord.CfId?.$oid,
          }
        : null;
    const refactoredNewRecord = newRecord
        ? {
              ...newRecord,
              CfId: newRecord.CfId?.$oid,
          }
        : null;

    const items = getFieldChangeItems(refactoredOldRecord, refactoredNewRecord, null, (field: string) =>
        getProcessedFieldChangeItems({ oldRecord, newRecord, oldItem, newItem, field }),
    );

    return <FieldChangeGrid items={items} />;
};

export { StudyHubStudyFieldsChangeGrid };
